import { surveyLocalization } from "../surveyStrings";

export var russianSurveyStrings = {
  pagePrevText: "Назад",
  pageNextText: "Далее",
  completeText: "Готово",
  startSurveyText: "Начать",
  otherItemText: "Другое (пожалуйста, опишите)",
  noneItemText: "Нет",
  selectAllItemText: "Выбрать всё",
  progressText: "Страница {0} из {1}",
  emptySurvey: "Нет ни одного вопроса.",
  completingSurvey: "Благодарим Вас за заполнение анкеты!",
  completingSurveyBefore:
    "Вы уже проходили этот опрос.",
  loadingSurvey: "Загрузка с сервера...",
  optionsCaption: "Выбрать...",
  value: "значение",
  requiredError: "Пожалуйста, ответьте на вопрос.",
  requiredErrorInPanel: "Пожалуйста, ответьте по крайней мере на один вопрос.",
  requiredInAllRowsError: "Пожалуйста, ответьте на вопросы в каждой строке.",
  numericError: "Ответ должен быть числом.",
  textMinLength: "Пожалуйста введите больше {0} символов.",
  textMaxLength: "Пожалуйста введите меньше {0} символов.",
  textMinMaxLength: "Пожалуйста введите больше {0} и меньше {1} символов.",
  minRowCountError: "Пожалуйста, заполните не меньше {0} строк.",
  minSelectError: "Пожалуйста, выберите хотя бы {0} вариантов.",
  maxSelectError: "Пожалуйста, выберите не более {0} вариантов.",
  numericMinMax:
    "'{0}' должно быть не меньше чем {1}, и не больше чем {2}",
  numericMin: "'{0}' должно быть не меньше чем {1}",
  numericMax: "'{0}' должно быть не больше чем {1}",
  invalidEmail: "Пожалуйста, введите действительный адрес электронной почты.",
  invalidExpression: "Выражение {0} должно возвращать 'true'.",
  urlRequestError: "Запрос вернул ошибку '{0}'. {1}",
  urlGetChoicesError:
    "Ответ на запрос пришел пустой или свойство 'path' указано неверно",
  exceedMaxSize: "Размер файла не должен превышать {0}.",
  otherRequiredError: "Пожалуйста, введите данные в поле 'Другое'",
  uploadingFile:
    "Ваш файл загружается. Подождите несколько секунд и попробуйте снова.",
  loadingFile: "Загрузка...",
  chooseFile: "Выберите файл(ы)...",
  confirmDelete: "Вы точно хотите удалить запись?",
  keyDuplicationError: "Это значение должно быть уникальным.",
  addColumn: "Добавить колонку",
  addRow: "Добавить строку",
  removeRow: "Удалить",
  addPanel: "Добавить новую",
  removePanel: "Удалить",
  choices_Item: "Вариант",
  matrix_column: "Колонка",
  matrix_row: "Строка",
  savingData: "Результаты сохраняются на сервер...",
  savingDataError: "Произошла ошибка, результат не был сохранён.",
  savingDataSuccess: "Результат успешно сохранён!",
  saveAgainButton: "Попробовать снова",
  timerMin: "мин",
  timerSec: "сек",
  timerSpentAll: "Вы потратили {0} на этой странице и {1} всего.",
  timerSpentPage: "Вы потратили {0} на этой странице.",
  timerSpentSurvey: "Вы потратили {0} в течение теста.",
  timerLimitAll:
    "Вы потратили {0} из {1} на этой странице и {2} из {3} для всего теста.",
  timerLimitPage: "Вы потратили {0} из {1} на этой странице.",
  timerLimitSurvey: "Вы потратили {0} из {1} для всего теста.",
  cleanCaption: "Очистить",
  clearCaption: "Очистить",
  removeFileCaption: "Удалить файл"
};

surveyLocalization.locales["ru"] = russianSurveyStrings;
surveyLocalization.localeNames["ru"] = "русский";



// WEBPACK FOOTER //
// ./src/localization/russian.ts